
module.exports = function removeEmptyTableHeader(md) {
  md.core.ruler.push('remove_empty_table_header', function remover(state) {
    const tokens = [];

    for (let i = 0; i < state.tokens.length; i++) {
      const token = state.tokens[i];
      if (token.type === 'thead_open') {
        let isEmptyHeader = true;
        let subToken;
        let j = i;
        do {
          j++;
          subToken = state.tokens[j];

          if (subToken.type !== 'inline') {
            continue;
          }

          if (subToken.content.trim() !== '') {
            isEmptyHeader = false;
            continue;
          }
        } while (subToken && subToken.type !== 'thead_close');

        if (isEmptyHeader) {
          i = j;
          continue;
        }
      }

      tokens.push(token);
    }

    state.tokens = tokens;
  });
};
